import React from 'react';
import s from './s.module.less';
import { Button, Drawer, Modal, Tabs } from 'antd';
import FAQSecion from './components/FAQSecion';
import { CALENDLY_LINK } from 'constants/common';
import { EWebinarScheduleType } from 'types/common';
import { getRandomString, helpLarkUrl, isMobile } from 'utils/common';
import { TFaqInfo } from 'types/operation';

type Props = {
    show?: boolean;
    onClose?: () => void;
    // Calendly widget 打开的 webinar 链接，默认 onboarding help
    webinarLink?: string;
};

export default function NeedHelp({ show = false, onClose, webinarLink }: Props) {
    const idRef = React.useRef<string>(getRandomString());
    const [currentTab, setCurrentTab] = React.useState<string>('1');
    const [showFaqModal, setShowFaqModal] = React.useState<boolean>(false);
    const timeOutRef = React.useRef<any>(null);
    const isSubmitted = React.useRef<boolean>(false);
    const isSuccessful = React.useRef<boolean>(false);
    const hasInit = React.useRef<boolean>(false);

    const webinarScheduleType = EWebinarScheduleType.KLARITY_ONBOARDING_HELP;
    const calendlyUrl = webinarLink || CALENDLY_LINK.KLARITY_ONBOARDING_HELP;

    React.useEffect(() => {
        if (show) {
            timeOutRef.current = setTimeout(() => {
                if (hasInit.current) {
                    return;
                }
                hasInit.current = true;
                (window as any).Calendly.initInlineWidget({
                    url: calendlyUrl,
                    // url: `https://calendly.com/kunqian-fan/11?${objString}`,
                    parentElement: document.getElementById(idRef.current),
                });
            }, 300);
        } else if (timeOutRef.current) {
            clearTimeout(timeOutRef.current);
        }
        return () => {
            if (timeOutRef.current) {
                clearTimeout(timeOutRef.current);
            }
        };
    }, [show, currentTab, calendlyUrl]);

    const doSubmit = async () => {
        if (!isSubmitted.current && webinarScheduleType) {
            isSubmitted.current = true;
            //const res = await calendlyProviderSave(webinarScheduleType);
        }
    };

    React.useEffect(() => {
        const isCalendlyScheduleEvent = (e: any) => {
            return (
                e.data.event && e.data.event.indexOf('calendly') === 0 && e?.data?.event === 'calendly.event_scheduled'
            );
        };
        const callback = (e: any) => {
            if (isCalendlyScheduleEvent(e)) {
                if (e?.data?.event === 'calendly.event_scheduled') {
                    doSubmit();
                }
            }
        };
        window.addEventListener('message', callback);
        return () => {
            window.removeEventListener('message', callback);
        };
    }, []);
    return (
        <Drawer
            open={show}
            width="80vw"
            onClose={onClose}
            placement={isMobile() ? 'bottom' : 'right'}
            rootClassName={s.drawer}
            height={isMobile() ? '90vh' : undefined}
            title={
                <div className={s.header}>
                    <span>Webinars & Resources</span>
                    <span onClick={onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M6 18L18 6M6 6L18 18"
                                stroke="#111827"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                </div>
            }
            closeIcon={null}
        >
            <div className={s.wrap}>
                <div className={s.item}>
                    <h4>Klarity provider FAQs</h4>
                    <div>Find quick answers to common onboarding and setup questions.</div>
                    <Button
                        type="primary"
                        onClick={() => {
                            setShowFaqModal(true);
                        }}
                    >
                        Open FAQ center
                    </Button>
                </div>
                <div className={s.item}>
                    <h4>Join support webinar</h4>
                    <div>
                        Connect with our team and other providers who are about to go live. Get practical tips and
                        guidance to ensure a smooth start.
                    </div>
                    <div id={idRef.current} className={s.calendlyWrap} />
                </div>

                {/* <Tabs defaultActiveKey="1" activeKey={currentTab} onChange={setCurrentTab}>
                    <Tabs.TabPane tab="FAQs" key="1">
                        <div className={s.faqWrap}>
                            <h3>Klarity Provider FAQs</h3>
                            <h4>1. Understanding Klarity and Getting Started</h4>
                            <div className={s.qaWrap}>
                                <FAQSecion data={FAQ1} />
                            </div>
                            <h4>2. Qualification and Account Creation</h4>
                            <div className={s.qaWrap}>
                                <FAQSecion data={FAQ2} />
                            </div>
                            <h4>3. Setting up Profile and Services</h4>
                            <div className={s.qaWrap}>
                                <FAQSecion data={FAQ3} />
                            </div>
                            <h4>4. License, Identity, and Payment</h4>
                            <div className={s.qaWrap}>
                                <FAQSecion data={FAQ4} />
                            </div>
                            <h4>5. Availability and Going Live </h4>
                            <div className={s.qaWrap}>
                                <FAQSecion data={FAQ5} />
                            </div>
                            <h4>6. No-Show and Cancellation Policy </h4>
                            <div className={s.qaWrap}>
                                <FAQSecion data={FAQ6} />
                            </div>
                            <h4>7. Patient Experience and Platform Features </h4>
                            <div className={s.qaWrap}>
                                <FAQSecion data={FAQ7} />
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Webinar session" key="2">
                        <div id={idRef.current} className={s.calendlyWrap} />
                    </Tabs.TabPane>
                </Tabs> */}
            </div>
            <Modal
                open={showFaqModal}
                onCancel={() => setShowFaqModal(false)}
                footer={null}
                width="90vw"
                style={{ top: 20 }}
                bodyStyle={{ padding: 0, height: '90vh' }}
            >
                <iframe src={helpLarkUrl} className={s.iframe} title="Klarity Provider FAQs" />
            </Modal>
        </Drawer>
    );
}
